import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { RouterModule } from '@angular/router';
import { LayoutHeaderComponent } from './layout-header/layout-header.component';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        BsDropdownModule,
        SharedModule,
        LayoutComponent,
        SidemenuComponent,
        LayoutHeaderComponent
    ]
})
export class LayoutModule { }
